"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/DifficultyLevel.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Locale_template = require("../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_attrs0 = {
        "class": "d-inline-flex align-items-center",
        style: "margin-left:-5px;"
      };

const Types = {
  beginner: 'success',
  intermediate: 'warning',
  advanced: 'danger'
};

function render(input, out, __component, component, state) {
  var data = input;

  out.be("span", marko_attrs0, "0", component);

  if (!input.onlyvalue) {
    out.e("i", {
        "class": marko_classValue("bx bx-radio-circle-marked float-left align-middle font-medium-4 " + Types[input.type])
      }, "1", component, 0, 1);
  }

  Locale_tag({
      class: "align-middle " + (input.onlyvalue ? Types[input.type] : ""),
      text: input.type.toCapitalCase()
    }, out, __component, "2");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
